import React from "react";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { QUOTE_QUERY } from "features/quote/queries";
import CompanyData from "./CompanyData";
import { emptyObject } from "constants/defaultValues";
import { useParams } from "react-router";
import { partnerTypes } from "constants/partnerTypes";

function CompanyDataContainer() {
  const { quoteId } = useParams();
  const { data } = useQueryWithErrorHandling(QUOTE_QUERY, { variables: { quoteId: parseInt(quoteId) } });
  const quote = data?.quote || emptyObject;
  return quote.partnerTypeId !== partnerTypes.individual && <CompanyData quote={quote} />;
}

export default CompanyDataContainer;
